import {
  Cloud,
  DotsThree,
  ForkKnife,
  GenderFemale,
  Heartbeat,
  PersonArmsSpread,
  Pulse,
  Syringe,
  Virus,
  Grains,
  HandHeart,
  Scan,
  HeadCircuit,
  PersonSimpleTaiChi,
  FlowerLotus
} from '@phosphor-icons/react'
import ScaleIcon from 'components/Icons/ScaleIcon'

export enum HealthGoalName {
  WeightLoss = 'weight_loss',
  MindfulEating = 'mindful_eating',
  GutHealth = 'gut_health',
  InsulinResistance = 'insulin_resistance',
  AthleticPerformance = 'athletic_performance',
  WomensHealth = 'womens_health',
  AutoimmuneDisease = 'autoimmune_disease',
  ChronicFatigue = 'chronic_fatigue',
  HeartDisease = 'heart_disease',
  FoodAllergies = 'food_allergies',
  ManagePreDiabetes = 'manage_pre_diabetes',
  CGMDataInterpretation = 'cgm_data_interpretation',
  Other = 'other',
  GeneralWellbeing = 'general_wellbeing',
  HealthyAging = 'healthy_aging',
  EmotionalEating = 'emotional_eating',
  PrePostNatalNutrition = 'pre_post_natal_nutrition',
  ThyroidDisorders = 'thyroid_disorders',
  StressManagement = 'stress_management',
  GeneralNutrition = 'general_nutrition',
  None = 'none'
}

export const HEALTH_GOALS = [
  {
    label: 'Weight loss',
    coachingLabel: 'Weight loss',
    value: HealthGoalName.WeightLoss,
    Icon: ScaleIcon
  },
  {
    label: 'Stress Management',
    coachingLabel: 'Stress Management',
    value: HealthGoalName.StressManagement,
    Icon: FlowerLotus
  },
  {
    label: 'Mindful Eating/Intuitive eating',
    coachingLabel: 'Mindful / Intuitive eating',
    value: HealthGoalName.MindfulEating,
    Icon: ForkKnife
  },
  {
    label: 'Gut Health',
    coachingLabel: 'Gut Health',
    value: HealthGoalName.GutHealth,
    Icon: Cloud
  },
  {
    label: 'Insulin Resistance',
    coachingLabel: 'Improve Insulin Sensitivity',
    value: HealthGoalName.InsulinResistance,
    Icon: Syringe
  },
  {
    label: 'Women’s Health (Menopause, PCOS, Fertility)',
    coachingLabel: 'Hormone Health (e.g. PCOS, menopause)',
    value: HealthGoalName.WomensHealth,
    Icon: GenderFemale
  },
  {
    label: 'Manage Pre Diabetes/Diabetes',
    coachingLabel: 'Support Pre Diabetes/Diabetes',
    value: HealthGoalName.ManagePreDiabetes,
    Icon: HandHeart
  },
  {
    label: 'Athletic Performance',
    coachingLabel: 'Athletic Performance',
    value: HealthGoalName.AthleticPerformance,
    Icon: PersonArmsSpread
  },
  {
    label: 'Chronic fatigue/Low energy levels',
    coachingLabel: 'Improve Energy Levels',
    value: HealthGoalName.ChronicFatigue,
    Icon: Pulse
  },
  {
    label: 'Autoimmune disease',
    coachingLabel: 'Immune System Support',
    value: HealthGoalName.AutoimmuneDisease,
    Icon: Virus
  },
  {
    label: 'Intolerances/Food Allergies',
    coachingLabel: 'Navigate Food Sensitivities',
    value: HealthGoalName.FoodAllergies,
    Icon: Grains
  },
  {
    label: 'Heart Disease',
    coachingLabel: 'Cardiovascular Wellness',
    value: HealthGoalName.HeartDisease,
    Icon: Heartbeat
  },
  {
    label: 'CGM Data Interpretation',
    coachingLabel: 'Understanding Glucose Trends (CGM support)',
    value: HealthGoalName.CGMDataInterpretation,
    Icon: Scan
  },
  {
    label: 'Other',
    coachingLabel: 'Other',
    value: HealthGoalName.Other,
    Icon: DotsThree
  }
]

export const CONSOLIDATED_VIDEO_CALL_HEALTH_GOALS = [
  {
    label: 'Weight Management',
    value: HealthGoalName.WeightLoss,
    Icon: ScaleIcon
  },
  {
    label: 'Stress Management',
    value: HealthGoalName.StressManagement,
    Icon: FlowerLotus
  },
  {
    label: 'Mindful, Intuitive & Emotional Eating',
    value: HealthGoalName.MindfulEating,
    Icon: ForkKnife
  },
  {
    label: 'Gut Health',
    value: HealthGoalName.GutHealth,
    Icon: Cloud
  },
  {
    label: 'Pre-Diabetes, Diabetes & Insulin Resistance',
    value: HealthGoalName.ManagePreDiabetes,
    Icon: Syringe
  },
  {
    label: "Women's Health (Menopause, PCOS, Fertility, Pre/Post Natal)",
    value: HealthGoalName.WomensHealth,
    Icon: GenderFemale
  },
  {
    label: 'Athletic Performance',
    value: HealthGoalName.AthleticPerformance,
    Icon: PersonArmsSpread
  },
  {
    label: 'Chronic fatigue/Low energy levels',
    value: HealthGoalName.ChronicFatigue,
    Icon: Pulse
  },
  {
    label: 'Autoimmune disease',
    value: HealthGoalName.AutoimmuneDisease,
    Icon: Virus
  },
  {
    label: 'Intolerances/Food Allergies',
    value: HealthGoalName.FoodAllergies,
    Icon: Grains
  },
  {
    label: 'Heart Disease',
    value: HealthGoalName.HeartDisease,
    Icon: Heartbeat
  },
  {
    label: 'Thyroid disorders',
    value: HealthGoalName.ThyroidDisorders,
    Icon: HeadCircuit
  },
  {
    label: 'General Wellness',
    value: HealthGoalName.GeneralWellbeing,
    Icon: PersonSimpleTaiChi
  },
  {
    label: 'Other',
    value: HealthGoalName.Other,
    Icon: DotsThree
  }
]
